import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import Global from '../../../store/global-selectors';
import { getActualSalesOrderIds } from '../../../store/orders/orders.helpers';
import { emptyArray } from 'ui-components/default-props/empty';
import { FulfillmentPlanOrderGridStatus } from '../../../enums/fulfillmentplan-order-grid-status';
import { getSelectedViewFromPathName } from '../../../pages/orders-page/orders-left-nav/orders-left-nav-context';
import { getOrderStatusFromViewName } from '../../../services/api/order-status-from-view-service';

const checkEligiblilityForGridStatus = (pathname, stores) => {
  const statusView = getSelectedViewFromPathName(pathname, stores);
  const requestStatusViewId = statusView?.parentId || statusView?.id;
  const status = getOrderStatusFromViewName(requestStatusViewId);
  const closedStatus =
    status === FulfillmentPlanOrderGridStatus.Shipped.name ||
    status === FulfillmentPlanOrderGridStatus.Cancelled.name ||
    status === FulfillmentPlanOrderGridStatus.PendingFulfillment.name ||
    status === FulfillmentPlanOrderGridStatus.RejectedFulfillment.name ||
    status === FulfillmentPlanOrderGridStatus.PendingPickup.name;

  return !closedStatus;
};

export const uniqueMarketPlaceIdsSelector = createSelector(
  (salesOrders) => salesOrders,
  (salesOrders) => {
    return salesOrders.reduce((accum, sorder) => {
      const marketPlaceId = sorder?.store?.marketplaceId;
      if (!accum.includes(marketPlaceId)) {
        accum.push(marketPlaceId);
      }
      return accum;
    }, []);
  },
);

export const useMultiOrder = (pathname) => {
  const isEligibleGridStatus = checkEligiblilityForGridStatus(pathname, emptyArray);
  const selectedIds = useSelector(Global.selectSelectedOrdersIds);
  const areAllSelected = useSelector(Global.selectSelectedOrdersAreAllOrdersSelected);
  const totalCount = useSelector(Global.selectOrdersGridTotalRecords);
  const selectedSalesOrderIds = useSelector((state) => getActualSalesOrderIds(state, selectedIds)) || emptyArray;
  const salesOrders =
    useSelector((state) =>
      Global.selectEntitiesSalesOrdersByIds(state, {
        salesOrderIds: selectedSalesOrderIds,
      }),
    ) || emptyArray;
  const uniqueMarketPlaceIds = useSelector(() => uniqueMarketPlaceIdsSelector(salesOrders));
  const uniqueMarketPlaceId = uniqueMarketPlaceIds.length && uniqueMarketPlaceIds.length === 1 ? uniqueMarketPlaceIds[0] : undefined;
  const fulfillmentPlans =
    useSelector((state) =>
      Global.selectEntitiesFulfillmentPlansByIds(state, {
        fulfillmentPlanIds: selectedIds,
      }),
    ) || emptyArray;
  const isRateJobRunning = useSelector(Global.selectOrdersDrawerIsLoadingRates);

  const isSuperSelect = selectedIds?.length === 0 && areAllSelected;

  return {
    ordersCount: areAllSelected ? totalCount : fulfillmentPlans.length,
    fulfillmentPlanIds: selectedIds,
    marketplaceId: uniqueMarketPlaceId,
    isSuperSelect,
    isEligibleGridStatus,
    isRateJobRunning,
  };
};
